//expects a number value and returns a localized currency string based on currency options, optionally including currency symbol
export function valueToCurrency(value, currencyOptions, includingCurrency) {

    let cleanValue = value.toFixed(2);

    if (includingCurrency !== false) {
        includingCurrency = true;
    }

    if (currencyOptions.separator !== '.') {
        cleanValue = cleanValue.replace(/\.([^.]*)$/, `${currencyOptions.separator}$1`);
    }

    if (value >= 1000 && currencyOptions.separator1k !== '') {
        let fullDigit = cleanValue.split(currencyOptions.separator);
        let preSep = fullDigit[0];
        let postSep = fullDigit[1] || '';

        if (preSep.length > 3) {
            preSep = preSep.substring(0, preSep.length - 3) + currencyOptions.separator1k + preSep.substring(preSep.length - 3);
        }

        cleanValue = preSep + (postSep ? currencyOptions.separator + postSep : '');
    }

    if (includingCurrency) {
        if (currencyOptions.position === '0') {
            cleanValue = cleanValue + ' ' + currencyOptions.currency;
        } else {
            cleanValue = currencyOptions.currency + ' ' + cleanValue;
        }
    }

    return cleanValue;
}

// expects a localized currency string and returns a number value, not needed for input (no currency symbol or no fee value)
export function currencyStringToValue(value, currencyOptions, generalOptions) {

    if (!value || value === generalOptions.nofee) {
        return 0.00;
    }

    const sanitizedValue = value
        .replace(currencyOptions.currency, '')
        .trim();

    return convertLocalizedStringToNumber(sanitizedValue, currencyOptions);
}

// removes seperators from string and returns a number value
export function convertLocalizedStringToNumber(input, currencyOptions) {

    if (typeof input !== 'string') {
        throw new Error('Input must be a string');
    }

    const escapedSeparator1k = currencyOptions.separator1k.replace(/[-.,]/g, '\\$&');
    const withoutThousands = input.replace(new RegExp(`(${escapedSeparator1k})(?=\\d{3})`, 'g'), '');

    const normalized = withoutThousands.replace(currencyOptions.separator, '.');

    const result = parseFloat(normalized);

    if (isNaN(result)) {
        return 0.00;
    }

    return result;
}


export function validateInput(input, currencyOptions, generalOptions) {

    const standardChars = `0-9.,`;
    const additionalChars = `${escapeRegExp(currencyOptions.separator)}${escapeRegExp(currencyOptions.separator1k)}`;
    const validRegex = new RegExp(`^[${additionalChars}${standardChars}]+$`);

    if (!validRegex.test(input)) {
        return valueToCurrency(convertLocalizedStringToNumber(generalOptions.standard, currencyOptions), currencyOptions, false);
    }

    const inputValue = roundTo(convertLocalizedStringToNumber(input, currencyOptions), currencyOptions, generalOptions);

    if (inputValue > parseFloat(generalOptions.max)) {
        return valueToCurrency(convertLocalizedStringToNumber(generalOptions.max, currencyOptions), currencyOptions, false);
    }

    if (inputValue < 1) {
        return valueToCurrency(1, currencyOptions, false);
    }

    return valueToCurrency(inputValue, currencyOptions, false);
}

export function parseCommaSeperatedNumber(input) {
    return parseFloat(input.replace(',', '.'));
}

export function roundTo(value, currencyOptions, generalOptions) {

    if (generalOptions.rounding_enable === '1') {
        const roundTo = convertLocalizedStringToNumber(generalOptions.rounding, currencyOptions);
        const result = Math.round(value / roundTo);
        value = result * roundTo;
    }

    const factor = Math.pow(10, 2);
    return Math.round(value * factor) / factor;
}

export function configStringToValidatedCurrencyString(string, currencyOptions, generalOptions, includingCurrency) {
    const value = currencyStringToValue(string, currencyOptions, generalOptions);
    return valueToCurrency(value, currencyOptions, includingCurrency);
}

function escapeRegExp(string) {
    return string.replace(/[-.]/g, '\\$&');
}


